module.exports = __webpack_public_path__ + "static/media/picture.1a7d6d58.png";